import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from '@separate/hooks/translation';
import { TagCircle } from '@separate/icons';
import styles from './couponAlert.module.scss';

const CouponAlert = (props) => {
  const { coupon, className } = props;
  const { t } = useTranslation();

  return (
    <div className={cx(styles.couponAlert, className)}>
      <div>
        <TagCircle />
      </div>
      <div>
        <p className={styles.title}>{t('premium.coupon.your_subscription', { coupon })}</p>
        <p className={styles.description}>{t('premium.coupon.discount_will_be_automatically_applied_at_checkout')}</p>
      </div>
    </div>
  );
};

CouponAlert.propTypes = {
  coupon: PropTypes.any,
  className: PropTypes.string
};

export default CouponAlert;
